import React from 'react';

export function renderRypilText(text) {
  if (text == null) return text;
  const raw = String(text);
  const parts = raw.split(/\brypil\b/gi);
  if (parts.length <= 1) return text;
  return parts.map((part, idx) => (
    <React.Fragment key={idx}>
      {part}
      {idx < parts.length - 1 ? <span className="rypil-word">rypil</span> : null}
    </React.Fragment>
  ));
}
